import type { ReactNode } from 'react';

type ChromeActionsProps = {
  primary?: ReactNode;
  secondary?: ReactNode[];
  onOpenActivityDrawer?: () => void;
};

export function ChromeActions({ primary, secondary = [], onOpenActivityDrawer }: ChromeActionsProps) {
  return (
    <>
      {primary}
      {secondary.map((item, idx) => (
        <span key={idx}>{item}</span>
      ))}
      {onOpenActivityDrawer ? (
        <button type="button" onClick={onOpenActivityDrawer} className="sr-only">
          Open activity
        </button>
      ) : null}
    </>
  );
}
